export default {
  name: 'GeofenceMap',
  props: {
    gapi: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      options: {
        gestureHandling: 'greedy',
        disableDefaultUI: false,
        streetViewControl: false,
        styles: [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }],
          },
        ],
      },
      polygonOptions: {
        editable: true,
        draggable: true,
        strokeColor: '#C27AF8',
        fillColor: '#C27AF8',
      },
      icon: {
        geoFence:
          'M10.5,26 C17.5,19.3170648 21,14.0809537 21,10.2916667 C21,4.60773612 16.2989899,0 10.5,0 C4.70101013,0 0,4.60773612 0,10.2916667 C0,14.0809537 3.5,19.3170648 10.5,26 Z',
      },
      colorIcon: {
        geoFence: '#296280',
      },
      clicks: 0,
      timer: null,
      delay: 100,
      paths: [],
      map: null,
      geoFencePoints: [],
      markers: [],
      googleMarkers: [],
      crudMode: 'view',
      AdvancedMarkerElement: null,
      editablePolygon: null,
    };
  },
  async mounted() {
    if (this.gapi == null) {
      console.error('Google API object is null. Cannot initialize the map.');
      return;
    }
    this.map = new this.gapi.maps.Map(this.$refs.mapGoogle, {
      center: { lat: -33.4283789, lng: -70.5407851 },
      zoom: 7,
      mapId: 'Geofence_id', // 🔴 OBLIGATORIO
      mapTypeId: 'terrain',
      gestureHandling: 'greedy', // Cambia aquí si quieres permitir gestos
      disableDefaultUI: false, // Muestra los controles por defecto (incluye zoom)
      streetViewControl: false, // Oculta Street View si lo deseas
      styles: [
        {
          featureType: 'poi',
          elementType: 'labels',
          stylers: [{ visibility: 'off' }],
        },
      ],
    });
    this.map.addListener('click', (mapsMouseEvent) => {
      if (this.paths.length === 0 && this.crudMode === 'edit') {
        const lat = mapsMouseEvent.latLng.lat();
        const lon = mapsMouseEvent.latLng.lng();
        this.paths = [];
        this.paths.push({
          lat: lat - 0.0232,
          lng: lon + 0.0225,
        });
        this.paths.push({
          lat: lat - 0.020392813,
          lng: lon - 0.020762692,
        });
        this.paths.push({
          lat: lat + 0.051566306,
          lng: lon + 0.05146616,
        });
        let bounds = new this.gapi.maps.LatLngBounds();
        this.paths.forEach((p) => {
          bounds.extend(new this.gapi.maps.LatLng(p.lat, p.lng));
        });
        this.map.fitBounds(bounds);
        // Crear polígono editable al iniciar
        this.initEditablePolygon();
      }
    });
  },
  methods: {
    getZonePoints() {
      return this.paths.map((p) => {
        return {
          lat: p.lat,
          lon: p.lng,
        };
      });
    },
    /**
     * Metodo que trae la información para editar de una geocerca especifica
     * @param {*} geoFence
     */
    setEditPolygon(gapi, geoFence) {
      console.log('Entre a editar el poligono ');
      this.paths = [];
      geoFence.zone.forEach((z) => {
        this.paths.push({
          lat: z.lat,
          lng: z.lon,
        });
      });
      this.initEditablePolygon();
      let bounds = new gapi.maps.LatLngBounds();
      geoFence.zone.forEach((z) => {
        bounds.extend(new gapi.maps.LatLng(z.lat, z.lon));
      });
      this.map.fitBounds(bounds);
    },
    reduceOnClick() {
      this.clicks++;
      if (this.clicks === 1) {
        this.timer = setTimeout(() => {
          this.reducePolygon();
          this.clicks = 0;
        }, this.delay);
      } else {
        clearTimeout(this.timer);
        this.clicks = 0;
      }
    },
    reducePolygon() {
      if (this.paths.length > 3) {
        this.paths.splice(-1);
        // Si hay polígono editable, también elimina el último punto visualmente
        if (this.editablePolygon) {
          const path = this.editablePolygon.getPath();
          if (path.getLength() > 3) {
            path.pop();
          }
        }
      }
    },
    updatePath(mvcArray) {
      this.paths = [];
      for (let i = 0; i < mvcArray.getLength(); i++) {
        for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
          let element = {
            lat: mvcArray.getAt(i).getAt(j).lat(),
            lng: mvcArray.getAt(i).getAt(j).lng(),
          };
          this.paths.push(element);
        }
      }
      this.verifyPolygonStatus();
    },
    verifyPolygonStatus() {
      this.polygonIsInside = true;
      this.polygonOptions.strokeColor = '#C27AF8';
      this.polygonOptions.fillColor = '#C27AF8';
    },
    setMapCenter(gapi, coordinates) {
      console.log('Tessst coordinadas ', coordinates);
      this.map.setCenter({
        lng: coordinates.lng,
        lat: coordinates.lat,
      });
      this.map.setZoom(18);
      console.log('bounds ');
    },
    async setGeoFences(gapi, geoFences, isArchived) {
      this.setMapNull();
      this.setGapi(gapi);
      const centerMap = this.prepareCenterPolygons(geoFences);

      this.map.setCenter(centerMap);
      //Los bounds hace que el mapa ajuste su zoom automaticamente
      let bounds = new gapi.maps.LatLngBounds();
      geoFences.forEach((g) => {
        if (g.zone) {
          //Si el mapa tiene 3 o mas puntos, se realiza el calculo con MIN y MAX.
          let latLowest = 99999999999999999999;
          let latHighest = -99999999999999999999;

          let lngLowest = 99999999999999999999;
          let lngHighest = -99999999999999999999;
          this.makePolygon(gapi, g.zone, isArchived);
          g.zone.forEach((z) => {
            bounds.extend(new gapi.maps.LatLng(z.lat, z.lon));
            if (z.lat < latLowest) {
              latLowest = z.lat;
            }

            if (z.lat > latHighest) {
              latHighest = z.lat;
            }

            if (z.lon < lngLowest) {
              lngLowest = z.lon;
            }

            if (z.lon > lngHighest) {
              lngHighest = z.lon;
            }
          });
          const lat = latLowest + (latHighest - latLowest) / 2;
          const lon = lngLowest + (lngHighest - lngLowest) / 2;

          this.prepareMarker(g, lat, lon);
        }
      });
      this.map.fitBounds(bounds);
    },
    /**
     * Prepara el centro de la zona segun el listado de puntos entregados
     * @param {Array} geoFences
     * @returns
     */
    prepareCenterPolygons(geoFences) {
      //Si el mapa tiene 3 o mas puntos, se realiza el calculo con MIN y MAX.
      let latLowest = 99999999999999999999;
      let latHighest = -99999999999999999999;

      let lngLowest = 99999999999999999999;
      let lngHighest = -99999999999999999999;

      geoFences.forEach((geoFence) => {
        if (geoFence.zone) {
          geoFence.zone.forEach((z) => {
            if (z.lat < latLowest) {
              latLowest = z.lat;
            }

            if (z.lat > latHighest) {
              latHighest = z.lat;
            }

            if (z.lon < lngLowest) {
              lngLowest = z.lon;
            }

            if (z.lon > lngHighest) {
              lngHighest = z.lon;
            }
          });
        }
      });
      return {
        lat: latLowest + (latHighest - latLowest) / 2,
        lng: lngLowest + (lngHighest - lngLowest) / 2,
      };
    },
    //Vacia el mapa
    setMapNull() {
      this.paths = [];
      this.markers = [];
      this.geoFencePoints.forEach((geoZone) => {
        geoZone.setMap(null);
      });
      this.cleanMapMarkers();
      // Limpia polígono editable
      if (this.editablePolygon) {
        this.editablePolygon.setMap(null);
        this.editablePolygon = null;
      }
    },
    changeMode(mode) {
      this.crudMode = mode;
      // Al cambiar a modo edición, dibuja el polígono editable
      // Limpia el polígono editable si existe
      if (this.editablePolygon) {
        this.editablePolygon.setMap(null);
        this.editablePolygon = null;
      }
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que importa el objeto al componente.
     * @param {Object} gapi
     */
    setGapi(gapi) {
      this.gapi = gapi;
    },
    cleanMapMarkers() {
      this.googleMarkers.forEach((gMarker) => {
        gMarker.map = null;
      });
      this.googleMarkers = [];
    },
    makePolygon(gapi, zone, isArchived) {
      let zonesFormat = [];
      zone.forEach((point) => {
        zonesFormat.push({
          lat: point.lat,
          lng: point.lon,
        });
      });
      const polygonZone = new gapi.maps.Polygon({
        paths: zonesFormat,
        strokeColor: isArchived ? 'rgba(128, 128, 128, 1)' : 'rgba(98, 38, 247, 1)',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: isArchived ? 'rgba(128, 128, 128, 1)' : 'rgba(98, 38, 247, 1)',
        fillOpacity: 0.35,
        map: this.map,
      });
      this.geoFencePoints.push(polygonZone);
    },
    async prepareMarker(geoFence, lat, lon) {
      // Importa el SVG como string o usa require para obtener la URL
      const mapMarker = require('../assets/CIRCULO.svg');

      // Crea un contenedor div para el SVG y el label
      const container = document.createElement('div');
      container.style.position = 'relative';
      container.style.width = '32px';
      container.style.height = '32px';

      // SVG como imagen
      const svgImg = document.createElement('img');
      svgImg.src = mapMarker;
      svgImg.style.width = '32px';
      svgImg.style.height = '32px';
      svgImg.style.display = 'block';

      // Label centrado
      const label = document.createElement('span');
      label.textContent = String(geoFence.index);
      label.style.position = 'absolute';
      label.style.top = '50%';
      label.style.left = '50%';
      label.style.transform = 'translate(-50%, -50%)';
      label.style.color = 'white';
      label.style.fontSize = '20px';
      label.style.fontWeight = 'bold';
      label.style.pointerEvents = 'none';

      container.appendChild(svgImg);
      container.appendChild(label);

      // Crea el marcador avanzado
      const marker = new this.gapi.maps.marker.AdvancedMarkerElement({
        position: { lat, lng: lon },
        map: this.map,
        content: container,
        title: 'GeoFence',
      });

      this.googleMarkers.push(marker);
    },
    /**
     * Inicializa el polígono editable y listeners nativos
     */
    initEditablePolygon() {
      // Limpia polígono anterior si existe
      if (this.editablePolygon) {
        this.editablePolygon.setMap(null);
        this.editablePolygon = null;
      }
      if (!this.gapi || !this.map || this.paths.length < 3) return;
      // Crea el polígono editable
      this.editablePolygon = new this.gapi.maps.Polygon({
        paths: this.paths,
        editable: true,
        draggable: true,
        strokeColor: this.polygonOptions.strokeColor,
        fillColor: this.polygonOptions.fillColor,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillOpacity: 0.35,
        map: this.map,
      });
      // Listener para click sobre el polígono (reduce puntos)
      this.gapi.maps.event.addListener(this.editablePolygon, 'click', (e) => {
        console.log(e);
        this.reduceOnClick();
        // Actualiza paths en el polígono y en el array
        this.updatePolygonPaths();
      });
      // Listeners para cambios en los paths (agregar, mover, quitar puntos)
      const path = this.editablePolygon.getPath();
      path.addListener('set_at', () => this.updatePolygonPaths());
      path.addListener('insert_at', () => this.updatePolygonPaths());
      path.addListener('remove_at', () => this.updatePolygonPaths());
    },
    /**
     * Sincroniza this.paths con los puntos actuales del polígono editable
     */
    updatePolygonPaths() {
      if (!this.editablePolygon) return;
      const path = this.editablePolygon.getPath();
      this.paths = [];
      for (let i = 0; i < path.getLength(); i++) {
        const latLng = path.getAt(i);
        this.paths.push({ lat: latLng.lat(), lng: latLng.lng() });
      }
      this.verifyPolygonStatus();
    },
  },
};
